import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Link,
  ModalHeader, useStyleConfig,
} from '@chakra-ui/react';
import ButtonContainer from '../Wrappers/ButtonContainer';
import { getMessage } from './utils';

const SubmitModal = ({ stateProps, formikProps, handleClose, message_raw }) => {
  const [header,message] = getMessage(stateProps, message_raw);
  const variant = 'wrapper';
  const link = stateProps.sectionData.fileUrl;
  if (stateProps.messageModal) {
    return (
      <>
        <Modal
          isCentered
          isOpen={stateProps.isOpen}
          onClose={stateProps.onClose}
        >
          <ModalOverlay />
          <ModalContent sx={{ margin: '16px' }}>
            <ModalHeader>{header}</ModalHeader>
            <ModalCloseButton />
            <ModalBody>{message}{link !== '' && (
              <Link href={link}> Click here to download again. </Link>
            )}</ModalBody>
            <ModalFooter>
              <ButtonContainer>
                <Button
                  sx={{ margin: ['0 0 8px', '0'] }}
                  onClick={() => handleClose(stateProps, formikProps,stateProps.onClose)}
                >
                  Close
                </Button>
              </ButtonContainer>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    );
  } else {
    return null;
  }
};

export default SubmitModal;
/*

                <Button
                  sx={{...buttonStyles.tertiary,...buttonStyles.cancel}}
                  onClick={stateProps.onClose}
                >
                  Cancel
                </Button>
 */
